import { MomentAdapter } from './momentAdapter';

const dateAdapter = (dateParam = new Date()) => new MomentAdapter(dateParam);

const validateDate = date =>
  date && dateAdapter(date).isValid() && dateAdapter(date).valueOf() > 0 && dateAdapter(date);

export default dateAdapter;
export { validateDate };
